import React, { PropTypes } from "react";
import { FormattedMessage, intlShape } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { RectangleSpinner } from "../../../../../common/spinners";
import { FollowUps } from "../../notes";
import { INCIDENT, SPECIAL_MODIFICATION } from "../../notes/enums/followUpTypes";
import { MemberHeader } from "./";

import * as dataActions from "../../../../../../utils/data/dataActions";
import {
    FOLLOW_UPS,
    FOLLOW_UPS_GRAPHQL_MEMBERS,
    IS_MINT_ENABLED,
    MEMBERS,
    MEMBER_COVERAGES,
} from "../../../../../../utils/data/models";

import { AGENT, INTERNAL_ROLES } from "../../../../../../utils/Roles";
import userHasAccess from "../../../../../../utils/userHasAccess";
import { Render } from "../../../../../common";
import { buildGraphQLQueryParams } from "../../../../../common/GraphQL/GraphQLQueryHelper";
import { isClientInTransition } from "../../../../../common/RouteValidators/ClientValidationHelper";
import { canViewSyncStatus, getLatestMemberSyncs } from "../../../../../common/synchronization/SynchronizationHelper";
import { MEMBER } from "../../../../synchronization/enums/syncElementTypes";
import { toast } from "react-toastify";
import * as types from "../../../../../../utils/data/dataActionTypes";
import { isMemberActivated } from "../../../../../../utils/services/memberActivationStatusService";
import { canViewActivationStatus } from "../../../../../common/MemberActivation/memberActivationHelper";
import simpleFetch from "../../../../../../../utils/simpleFetch";
import { fixClientURL, getClientIDFromURL } from "../../../../../common/clientHelper";

class MemberPage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            clientInTransition: undefined,
            isSyncReady: false,
            client: {},
            clientId: null,
            activationStatus: null,
            isMintEnabledResponse: false,
            isMemberLoading: false
        };

        this.archiveMember = this.archiveMember.bind(this);
        this.generateMemberCoveragesLabels = this.generateMemberCoveragesLabels.bind(this);
        this.getMember = this.getMember.bind(this);
        this.updateMember = this.updateMember.bind(this);
        this.updateMemberNote = this.updateMemberNote.bind(this);
        this.refetchIsTransition = this.refetchIsTransition.bind(this);
        this.isMemberHashValid = this.isMemberHashValid.bind(this);
        this.getGraphQLQuery = this.getGraphQLQuery.bind(this);
        this.getFollowUps = this.getFollowUps.bind(this);
        this.fetchMemberMintStatus = this.fetchMemberMintStatus.bind(this);

    }

    componentWillMount() {
        this.getMember().then(() => {
            this.fetchMemberMintStatus();
            if (canViewSyncStatus(this.state.client, MEMBER)) {
                this.isMemberHashValid();
            }
            isClientInTransition(this.state.clientId).then((res) => {
                /** Response is either true or false. */
                this.setState({ clientInTransition: res });
            });

            if (userHasAccess(AGENT)) {
                this.getFollowUps();
            }
        });
    }


    fetchMemberMintStatus() {
        if(!userHasAccess(INTERNAL_ROLES)) {
            return;
        }
        const memberId = this.props.memberId;
        simpleFetch("get", IS_MINT_ENABLED.path, {}).then((res) => {
            if (memberId !== this.props.memberId) {
                return;  // Ignore if user switched members
            }
            this.setState({ isMintEnabledResponse: res.isEnabled }, () => {
                if(canViewActivationStatus(this.state.client.clientBillingPeriodType, this.state.isMintEnabledResponse)) {
                    this.fetchActivationStatus();
                }
            });
        }).catch((e) => {
            if (memberId !== this.props.memberId) {
                return;  // Ignore if user switched members
            }
            toast(<FormattedMessage id="validation.customMessages.serverErrors.genericError" />, {
                type: toast.TYPE.ERROR,
                autoClose: false,
            });
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.memberId != nextProps.memberId) {
            this.setState({
                activationStatus: null,
                isMintEnabledResponse: false,
                isMemberLoading: true
            });
            this.props.dataActions.clearDataList(MEMBERS);
            this.getMember(nextProps.memberId).then(() => {
                this.setState({ isMemberLoading: false });
                if (userHasAccess(AGENT)) {
                    this.getFollowUps();
                }

                this.fetchMemberMintStatus();
            });
        }
    }

    componentWillUnmount() {
        this.props.dataActions.clearDataList(MEMBERS);
        this.props.dataActions.clearDataList(FOLLOW_UPS_GRAPHQL_MEMBERS);
    }

    getGraphQLQuery(filter, sortBy, offset, limit, queryName, q) {
        const colsStr = `
    followUpId
    priority
    createdAt
    transactionAmount
    updatedAt
    clientId
    memberId
    closedDate
    createdByUserId
    recipientUserId
    followUpCategoryId
    incidentType
    createdByUser {
        firstName
        lastName
      }
    closedByUser {
        firstName
        lastName
    }
    deadline
    description
    client {
        name
        isArchived
    }
    followUpType
    followUpOriginType
    member {
        memberId
        firstName
        lastName
        memberIdentifier
        isArchived
    }
    followUpStatusType
    descriptionKey
    recipientUser {
        firstName
        lastName
        emailAddress
      }
    relatedUser {
      firstName
      lastName
      emailAddress
      associatedClientIds
    }
    commentsCount
    attachmentsCount
    followUpGuid
    specialModificationType
    `;

        return buildGraphQLQueryParams("followUps", filter, sortBy, offset, limit, colsStr, queryName, q, `sectionType: "MEMBERS"`);
    }

    getFollowUps() {
        const filter = `follow_ups.member_id==${this.props.memberId}`;
        const graphQLQuery = this.getGraphQLQuery(filter, "follow_ups.created_at:desc", 0, 200, "getFollowUps", "");
        this.props.dataActions.getGraphQL(FOLLOW_UPS_GRAPHQL_MEMBERS, { query: graphQLQuery }, "");
    }

    isMemberHashValid() {
        const { memberId } = this.props;
        getLatestMemberSyncs(this.state.clientId, [memberId], this.props.dataActions, () => {
            this.setState({ isSyncReady: true });
        });
    }

    archiveMember(memberId, isArchived) {
        this.props.dataActions.updateDataItem(MEMBERS, { memberId, isArchived: !isArchived }).then(() => {
            this.getMember(memberId);
        });
    }

    refetchIsTransition() {
        isClientInTransition(this.state.clientId).then((res) => {
            /** Response is either true or false. */
            this.setState({ clientInTransition: res });
        });
    }

    createMemberNote(fields) {
        const { clientId } = this.state;
        const values = {
            createdByUserId: fields.userId,
            description: fields.description,
            attachments: fields.followUpAttachments,
            followUpGuid: fields.followUpGuid,
            followUpOriginType: fields.followUpOriginType,
            followUpStatusType: "OPEN",
            followUpType: fields.followUpType,
            memberId: fields.memberId,
            transactionAmount: fields.transactionAmount || null,
            followUpCategoryId: fields.followUpCategoryId,
            clientId: clientId,
            memberIdentifier: fields.memberIdentifier,
        };
        if (fields.priority) {
            values.priority = fields.priority;
            values.deadline = fields.deadline;
        }
        if (fields.generateFollowUp) {
            switch (fields.followUpType) {
                case INCIDENT.value: {
                    values.incidentType = fields.subType;
                    break;
                }
                case SPECIAL_MODIFICATION.value: {
                    values.specialModificationType = fields.subType;
                    break;
                }
            }
            values.recipientUserId = fields.recipientUserId;
        }
        this.props.dataActions.createDataItem(FOLLOW_UPS, values).then(() => {
            this.getFollowUps();
        });
    }

    generateMemberCoveragesLabels() {
        const { formatDate, formatMessage } = this.context.intl;
        const dateFormat = {
            year: "numeric",
            month: "long",
            day: "2-digit",
            timeZone: "UTC",
        };

        return this.props.activeMemberCoverages.map((coverage) => {
            let label = "";

            if (!coverage.endDate) {
                label += formatMessage({
                    id: "memberCoverages.datatable.columns.periodFrom",
                });
            }

            label += formatDate(coverage.startDate, dateFormat);

            if (!!coverage.endDate) {
                label += " - " + formatDate(coverage.endDate, dateFormat);
            }

            return { value: coverage.memberCoverageId, text: label, ...coverage };
        });
    }

    getMember(memberId) {
        let memberId_ = !!memberId ? memberId : this.props.memberId;
        const coveragesFilters = [`memberCoverages.memberId==${memberId_}`, "memberCoverages.isInactive==false"];
        const coveragesFields = "endDate, startDate, memberCoverageId, isInactive";
        let fieldsToFilterAgentAndService = ",client(accountManager(userId,firstName,lastName,emailAddress,phone,roleId),serviceRepresentative(userId,firstName,lastName,emailAddress,phone,roleId),*)";
        let fields = `memberCoverages(memberCoverageGuarantees(*),*),dependentPersons(*),beneficiaries(isArchived),*${fieldsToFilterAgentAndService}`;
        return this.props.dataActions
            .getDataItem(MEMBERS, memberId_, {
                fields: fields
            })
            .then((data) => {
                if (data && data.type === types.GET_DATA_ITEM_SUCCESS) {
                    const clientIDInURL = getClientIDFromURL();
                    if(Number(data.payload.data.clientId) !== Number(clientIDInURL)) {
                        fixClientURL(data.payload.data.clientId);
                        return;
                    }
                    this.setState(
                        {
                            client: data.payload.data.client,
                            clientId: data.payload.data.clientId
                        }
                    );
                }
                else {
                    toast(<FormattedMessage id="validation.customMessages.serverErrors.genericError" />, {
                        type: toast.TYPE.ERROR,
                        autoClose: false,
                    });
                }
                this.props.dataActions.getDataList(
                    { ...MEMBER_COVERAGES, name: "activeMemberCoverages" },
                    0,
                    0,
                    "",
                    ["startDate:desc"],
                    coveragesFilters,
                    {},
                    {},
                    coveragesFields,
                    "MEMBER"
                );
            }).then(() => {
                this.props.dataActions.getDataList(
                    { ...MEMBER_COVERAGES, name: "allMemberCoverages" },
                    0,
                    0,
                    "",
                    ["startDate:desc"],
                    [`memberCoverages.memberId==${memberId_}`],
                    {},
                    {},
                    coveragesFields,
                    "MEMBER"
                );
            });
    }

    updateMember(values) {
        this.props.dataActions.updateDataItem(MEMBERS, values).then(() => {
            this.getMember();
            if (canViewSyncStatus(this.state.client, MEMBER)) {
                this.isMemberHashValid();
            }
        });
    }

    updateMemberNote(values) {
        let memberId = values.memberId; /** Can be int in some cases. */
        if (typeof memberId == "string") {
            memberId = values.memberId.trim() ? values.memberId : null;
        }
        /** Need to be set to null cause db wont accept string for int field. */
        const dataToUpdate = {
            attachments: values.followUpAttachments,
            followUpId: values.followUpId,
            followUpType: values.followUpType,
            description: values.description,
            transactionAmount: values.transactionAmount || null,
            recipientUserId: values.recipientUserId,
            followUpCategoryId: values.followUpCategoryId,
            clientId: values.clientId,
            memberId: memberId,
            memberIdentifier: values.memberIdentifier,
        };
        if (values.priority) {
            dataToUpdate.priority = values.priority;
            dataToUpdate.deadline = values.deadline;
        }
        if (!values.memberId) {
            dataToUpdate.memberName = values.memberName;
            dataToUpdate.memberIdentifier = values.memberIdentifier;
            dataToUpdate.memberClient = values.memberClient;
            dataToUpdate.memberPhoneNumber = values.memberPhoneNumber;
            dataToUpdate.memberEmailAddress = values.memberEmailAddress;
        }
        if (values.generateFollowUp) {
            switch (values.followUpType) {
                case INCIDENT.value: {
                    dataToUpdate.incidentType = values.subType;
                    dataToUpdate.specialModificationType = null;
                    break;
                }
                case SPECIAL_MODIFICATION.value: {
                    dataToUpdate.specialModificationType = values.subType;
                    dataToUpdate.incidentType = null;
                    break;
                }
            }
        }
        if (values.closeFollowUp) {
            dataToUpdate.followUpStatusType = "CLOSED";
            dataToUpdate.closedDate = new Date();
            dataToUpdate.closedByUserId = this.props.auth.user.userId;
            dataToUpdate.closedDescription = values.closedDescription;
        } else {
            dataToUpdate.followUpStatusType = "OPEN";
            dataToUpdate.closedDate = null;
            dataToUpdate.closedByUserId = null;
            dataToUpdate.closedDescription = null;
        }
        return this.props.dataActions.updateDataItem(FOLLOW_UPS, dataToUpdate).then(() => {
            this.getFollowUps();
        });
    }

    fetchActivationStatus(memberId) {
        const currentMemberId = memberId || this.props.memberId;
        if (!currentMemberId) {
            return;
        }

        const memberIdAtCallStart = this.props.memberId;
        isMemberActivated(this.props.member)
            .then(result => {
                if (memberIdAtCallStart !== this.props.memberId) {
                    return;  // Ignore if user switched members
                }
                this.setState({ activationStatus: result });
            })
            .catch((e) => {
                if (memberIdAtCallStart !== this.props.memberId) {
                    return;  // Ignore if user switched members
                }
                toast(<FormattedMessage id="validation.customMessages.serverErrors.genericError" />, {
                    type: toast.TYPE.ERROR,
                    autoClose: false,
                });
                throw e;
            });
    }

    render() {
        return (
            <div className="full-height">
                {this.props.member ? (
                    <div className="member-page">
                        <div className="header-form">
                            <MemberHeader
                                path={this.props.path}
                                latestMemberSync={this.props.latestMemberSync}
                                clientInTransition={this.state.clientInTransition}
                                isSyncReady={this.state.isSyncReady}
                                member={this.props.member}
                                clientId={this.state.clientId}
                                client={this.state.client}
                                occupation={this.props.dataActions.occupation}
                                memberId={this.props.memberId}
                                activeMemberCoverages={this.generateMemberCoveragesLabels()}
                                allMemberCoverages={this.props.allMemberCoverages}
                                archiveMember={this.archiveMember}
                                onSubmit={this.updateMember}
                                authLanguageCode={this.props.authLanguageCode}
                                refetchIsTransition={this.refetchIsTransition}
                                activationStatus={this.state.isMemberLoading ? null : this.state.activationStatus}
                                isMintEnabled={this.state.isMemberLoading ? false : this.state.isMintEnabledResponse}
                                beneficiaryCount={
                                    this.props.member && this.props.member.beneficiaries && this.props.member.beneficiaries.filter(
                                        (beneficiary) => beneficiary.isArchived === false
                                    ).length
                                }
                            />
                            <div className="sub-container">
                                {React.cloneElement(this.props.children, {
                                    getMember: this.getMember,
                                })}
                            </div>
                        </div>
                        <Render for={AGENT}>
                            <FollowUps
                                type="member"
                                createNote={this.createMemberNote.bind(this)}
                                auth={this.props.auth}
                                client={this.state.client}
                                member={this.props.member}
                                followUps={this.props.followUps}
                                updateNote={this.updateMemberNote}
                                clientId={this.state.clientId}
                                needsActiveProperty={true}
                            />
                        </Render>
                    </div>
                ) : (
                    <RectangleSpinner className="member-page-spinner" />
                )}
            </div>
        );
    }
}

MemberPage.propTypes = {
    activeMemberCoverages: PropTypes.array,
    authLanguageCode: PropTypes.string,
    auth: PropTypes.object,
    children: PropTypes.node,
    followUps: PropTypes.array,
    member: PropTypes.object,
    dataActions: PropTypes.object,
    memberId: PropTypes.string,
    path: PropTypes.string,
    occupation: PropTypes.string,
    latestSyncs: PropTypes.object,
    latestMemberSync: PropTypes.object,
    allMemberCoverages: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};

MemberPage.contextTypes = {
    intl: intlShape,
};

function mapStateToProps(state, ownProps) {
    const members = state.data.members || {};
    const followUps = state.data.followUpsMembers || {};
    const activeMemberCoverages = state.data.activeMemberCoverages || {};
    const allMemberCoverages = state.data.allMemberCoverages ? state.data.allMemberCoverages.items : {};
    const latestSyncs = state.data.latestSyncs || [];

    let latestMemberSyncs = null;
    let latestMemberSync = null;

    if (latestSyncs && latestSyncs.hasOwnProperty("active")
        && latestSyncs["active"].hasOwnProperty("memberSyncs")) {
        latestMemberSyncs = latestSyncs["active"]["memberSyncs"];

        if (latestMemberSyncs && latestMemberSyncs.length > 0) {
            latestMemberSync = latestMemberSyncs[0];
        }
    }

    return {
        activeMemberCoverages: activeMemberCoverages.items || [],
        allMemberCoverages: allMemberCoverages || [],
        authLanguageCode: state.auth.user.languageCode,
        path: ownProps.location.pathname,
        memberId: ownProps.params.memberId,
        auth: state.auth,
        followUps: followUps.items || null,
        member: members.active,
        occupation: ownProps.params.occupation,
        latestMemberSync,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dataActions: bindActionCreators(dataActions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MemberPage);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/MemberPage.js